import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/skincare';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            精选文章
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            由皮肤科医生和配方师精心撰写，为你提供最专业的极简护肤知识
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} {...article} />
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="/category/jijian-hufu"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300 text-foreground-700 rounded-full text-sm hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}